const sortByDate = (a: Date, b: Date) => {
  let aDate: any = new Date(a);
  let bDate: any = new Date(b);
  if (aDate === "Invalid Date") aDate = new Date(0);
  if (bDate === "Invalid Date") aDate = new Date(0);
  return bDate.getTime() - aDate.getTime();
};

export default sortByDate;
